import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/PhysicalSecurity/g6-pro-dome.jpg";
import type { Product } from "../../types";
import { domeTurret } from "../product-groups/cameraSecurity/DomeTurret";
import { domeTurret as productListDomeTurret } from "../product-list-groups/domeTurret";
import { deployment, outdoorReady } from "../properties";

export const g6ProDome: Product = {
  id: "g6ProDome",
  productTitle: "G6 Pro Dome",
  isNew: true,
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-g6-pro-dome`],
  storePathParts: {
    productSlug: "uvc-g6-pro-dome",
    category: "cameras-dome-turret",
  },
  description: "g6ProDome.description",
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: image,
    width: 250,
    height: 182,
  },
  productGroup: domeTurret,
  productListGroup: productListDomeTurret,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø163.8 × 108.8 mm\n(Ø6.45 × 4.28")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/1.2" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g6ProDome.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: {
        type: "translation",
        value: "g6ProDome.nightVision",
      },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: {
        type: "translation",
        value: "commons.cameraAudio.microphone",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK10" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE+" },
    },
  ],
};
